<template>
    <div class="count">
        <ButtonIcon
            :onClick="() => decrease(count, min)"
            :ariaLabel="ariaLabelDecrease"
            color="black"
            variant="border"
            icon="Minus"
            :noPadding="true"
            :size="buttonSize"
            :disabled="count === min" />
        <span class="count-value">{{ count }}</span>
        <ButtonIcon
            :onClick="() => increase(count, max)"
            :ariaLabel="ariaLabelIncrease"
            color="black"
            variant="border"
            icon="Plus"
            :noPadding="true"
            :size="buttonSize"
            :disabled="count === max" />
    </div>
</template>

<script lang="ts">
    import { defineComponent, PropType, ref, watch } from 'vue';
    import { Size as ButtonSize } from '@ui/components/Button/Button.interfaces';
    import { t } from '@shared/helpers/translation';
    import ButtonIcon from '@ui/components/Button/ButtonIcon.vue';

    export default defineComponent({
        name: 'Count',
        components: { ButtonIcon },
        props: {
            modelValue: {
                type: Number as PropType<number | null>,
            },
            min: Number,
            max: Number,
            buttonSize: {
                type: String as PropType<ButtonSize>,
                default: 'm',
            },
            name: {
                type: String,
            },
        },
        emits: ['update:modelValue'],
        setup(props, { emit }) {
            const count = ref<number>(props.modelValue || 0);

            watch(
                () => props.modelValue,
                (newValue) => (count.value = newValue || 0)
            );

            const increase = (val: number, max: number | undefined) => {
                (!max || max > val) && emit('update:modelValue', val + 1);
            };

            const decrease = (val: number, min: number | undefined) => {
                (!min || min < val) && emit('update:modelValue', val - 1);
            };

            const getAriaLabels = () => ({
                ariaLabelIncrease: props.name
                    ? t({ key: 'aria.add_one_item', values: [props.name] })
                    : '',
                ariaLabelDecrease: props.name
                    ? t({ key: 'checkout.remove_product', values: [props.name] })
                    : '',
            });

            const { ariaLabelIncrease, ariaLabelDecrease } = getAriaLabels();

            return {
                count,
                ariaLabelIncrease,
                ariaLabelDecrease,
                increase,
                decrease,
            };
        },
    });
</script>

<style lang="scss" scoped>
    @forward './Count.scss';
</style>
